<p-confirmDialog header="Confirmation" icon="fa fa-question-circle" width="425" #cd>
  <p-footer>
    <button type="button" pButton icon="fa-check" label="Yes" (click)="cd.onAccept()"></button>
    <button type="button" pButton icon="fa-close" label="Cancel" (click)="cd.onReject()"></button>
  </p-footer>
</p-confirmDialog>

<search-form #searchForm (search)="setFilter([
    {'field':'firstname', 'value':firstname.value},
    {'field':'lastname', 'value':lastname.value},
    {'field':'email', 'value':email.value}
    ])" (reset)="firstname.value=''; lastname.value=''; email.value=''; setFilter([]); searchForm.hide()">
  <mat-form-field class="col-4">
    <input matInput #firstname placeholder="Filter by first name" [autofocus]="true" class="full-width" />
  </mat-form-field>
  <mat-form-field class="col-4">
    <input matInput #lastname placeholder="Filter by last name" class="full-width" />
  </mat-form-field>
  <mat-form-field class="col-4">
    <input matInput #email placeholder="Filter by e-mail" class="full-width" />
  </mat-form-field>
</search-form>

@if (!editing) {
  <admins-list [items]="(items | async) || []" (selected)="itemSelected($event)" (added)="newItem()" (search)="searchForm.show()"
    (deleted)="deleteItem($event)"
  [(sortSettings)]="sortSettings" [(paging)]="paging"></admins-list>
}
@if (!!editing) {
  <admin-form [item]="selectedItem | async" [errorMsgs]="(errorMsg | async) || []" (canceled)="editCancel()" (saved)="saveItem($event)"></admin-form>
}
